import { transformTreeShakeClient } from "./vite/plugins/clientTreeShakePlugin";
import { renderKotlinSourceModule } from "./vite/plugins/kotlinSourceModule";
import { renderSwiftPackageModule } from "./vite/plugins/swiftPackageModule";
function renderNativeSourceModule(id, platform, root) {
  return id.endsWith(".kt") ? renderKotlinSourceModule(id, platform, root) : renderSwiftPackageModule(id, platform, root);
}
export {
  renderNativeSourceModule,
  transformTreeShakeClient
};
//# sourceMappingURL=native-transforms.js.map
